module.exports = __webpack_public_path__ + "img/grass-1.88b2db6d.png";